// removed by extract-text-webpack-plugin
module.exports = {"root":"Alert__root-1wimL","close":"Alert__close-3WE1v","html":"Alert__html-PSSe0"};